export const timeslotKindConstants = {
	BOOKING: 'booking',
	LUNCH: 'lunch',
	MEETING_ROOM: 'meeting_room',
	TRANSPORT: 'transport',
	CUSTOM: 'custom',
};

export const timeslotSubKindConstants = {
	BOOKING: 'booking',
	LUNCH: 'lunch',
	MEETING_ROOM: 'meeting_room',
	TRANSPORT: 'transport',
	CUSTOM_1: 'custom_1',
	CUSTOM_2: 'custom_2',
	CUSTOM_3: 'custom_3',
	CUSTOM_4: 'custom_4',
	CUSTOM_5: 'custom_5',
	CUSTOM_6: 'custom_6',
	CUSTOM_7: 'custom_7',
	CUSTOM_8: 'custom_8',
	CUSTOM_9: 'custom_9',
	CUSTOM_10: 'custom_10',
	CUSTOM_11: 'custom_11',
	CUSTOM_12: 'custom_12',
	CUSTOM_13: 'custom_13',
	CUSTOM_14: 'custom_14',
	CUSTOM_15: 'custom_15',
	CUSTOM_16: 'custom_16',
	CUSTOM_17: 'custom_17',
	CUSTOM_18: 'custom_18',
	CUSTOM_19: 'custom_19',
	CUSTOM_20: 'custom_20',
	CUSTOM_21: 'custom_21',
	CUSTOM_22: 'custom_22',
	CUSTOM_23: 'custom_23',
	CUSTOM_24: 'custom_24',
	CUSTOM_25: 'custom_25',
};
